import React from 'react';
import config from '../../../../config/config';
import {
  isCollegeExchange,
  isExchange,
  isRecurringBuy,
} from '../../../../utils/transactions-util';
import { isProductType529 } from '../../../../utils/funds/funds-utility';
import If from '../../../Shared/If/If';

const RestrictedCountryFundNoteTip = (fund = {}) => (
  <span className="exclude">
    Requires permanent US address to{' '}
    {isExchange() || isCollegeExchange() ? 'exchange' : 'purchase'}.&nbsp;
    <If
      test={
        (!isProductType529(fund.productType) && isRecurringBuy()) ||
        !isRecurringBuy()
      }
    >
      <a
        href={`${config.url}/usis/my-accounts/profile/contact-information`}
        className="college-branded-link exclude"
        title="Change Address"
      >
        Change Address
      </a>
    </If>
  </span>
);

export default RestrictedCountryFundNoteTip;
